import {$, w} from './constants';

w.load(() => {
    console.log('Hello world from El Cultivo! --Load');
    if( $('.bg-dk').length ){
      if($(window).width() < 968){
          $(".bg-dk").css("background-image", "url(" + bgM + ")");
      }else if($(window).width() > 968){
          $(".bg-dk").css("background-image", "url(" + bgD + ")");
      }
    }
   
});

$(document).ready(function() {
  console.log('Hello world from El Cultivo! --Ready'); 
  let bg_single = $('#bg-single').css("background-color");
  $('header').css('background-color', bg_single);
  
})

// ____ M E N Ú ____

const hamburger = document.querySelector(".hamburger");
const lista = document.querySelector(".menu__responsive");

hamburger.addEventListener("click", mobileMenu);
// lista.addEventListener("click", mobileMenu );

function mobileMenu() {
    hamburger.classList.toggle("active");
    lista.classList.toggle("active");
}

$('#id_slide').slick({
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

$("#hover-contact").hover(
  function() {
    $('.contact').addClass("bg-contact");
  }, function() {
    $('.contact').removeClass("bg-contact");
  }
);

$('.form__trigger').click(function(){
  $(this).addClass('active');
})


const slider = document.querySelector('.scroll_gallery-aux');
let isDown = false;
let startX;
let scrollLeft;

if(slider){



slider.addEventListener('mousedown', (e) => {
  isDown = true;
  slider.classList.add('active');
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
});
slider.addEventListener('mouseleave', () => {
  isDown = false;
  slider.classList.remove('active');
});
slider.addEventListener('mouseup', () => {
  isDown = false;
  slider.classList.remove('active');
});
slider.addEventListener('mousemove', (e) => {
  if(!isDown) return;
  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX) * 3; //scroll-fast
  slider.scrollLeft = scrollLeft - walk;
  console.log(walk);
});
}


$('.catering__description-image').slick({
  infinite: true,
  speed: 500,
  autoplay: false,
  fade: true,
  arrows: true,
  prevArrow: '<div class="arrow arrow--left">',
  nextArrow: '<div class="arrow arrow--right">',
  lazyLoad: 'ondemand',
  responsive: [
      {
          breakpoint: 951,
          settings: {
           swipeToSlide: true,
           swipe: true
          }
      }
  ]
});

let previousScroll = 0;
    const $header = $('header');
    const headerOrgOffset = $header.offset().top;
  
    if($(window).width() < 780){
      $(window).scroll(function() {
        const currentScroll = $(this).scrollTop();

        if(currentScroll > headerOrgOffset + 30) {
            if (currentScroll > previousScroll) {
                $header.fadeOut();
            } else {
                $header
                  .fadeIn()
                  .addClass('fixed');
            }
        } else {
             $header.removeClass('fixed');   
        }
        previousScroll = currentScroll;
      });
    }